import { createContext, Fragment, useEffect, Suspense } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { cx } from "class-variance-authority";
import { useData } from "@/stores/data";
import { getCurrentApp } from "@/helpers/h";

import Navbar from "../components/navbars/Navbar";
import Sidebar from "../components/sidebars/Sidebar";
import Export from "./Export/Export";
import WorkerHelpers from "../helpers/WorkerHelpers";
import SidebarMobile from "../components/sidebars/SidebarMobile";
import Import from "./Import";
import LoadingSpinner from "../components/LoadingSpinner";
import { useWs } from "@/hooks/useWs";
import { useSetting } from "@/hooks/useSetting";

// Global Context
export const globalContext = createContext();

// Layout for all pages
export default function Layout() {
  const loc = useLocation();

  // refactored
  const {
    isAuth,
    currentExport,
    sidebarState,
    currentImport,
    breadCrumb,
    setSidebarState,
  } = useData();

  // ws
  useWs(isAuth);

  // Fetch setting in background
  useSetting();

  // Redirect if not login
  useEffect(() => {
    if (isAuth && isAuth.app == "bts") {
      if (getCurrentApp() == "admin" && isAuth.data.role != "admin")
        return (window.location.href = "/auth/login");
      if (getCurrentApp() == "service-engineer" && isAuth.data.role != "se")
        return (window.location.href = "/auth/login");
      if (getCurrentApp() == "service-desk" && isAuth.data.role != "sd")
        return (window.location.href = "/auth/login");
      if (
        getCurrentApp() == "remote-operation-center" &&
        isAuth.data.role != "roc"
      )
        return (window.location.href = "/auth/login");
      if (getCurrentApp() == "logistic" && isAuth.data.role != "log")
        return (window.location.href = "/auth/login");
      if (getCurrentApp() == "repair-center" && isAuth.data.role != "rce")
        return (window.location.href = "/auth/login");
      if (getCurrentApp() == "team-leader" && isAuth.data.role != "tl")
        return (window.location.href = "/auth/login");
      if (getCurrentApp() == "manager" && isAuth.data.role != "mgr")
        return (window.location.href = "/auth/login");
      if (getCurrentApp() == "flm" && isAuth.data.role != "flm")
        return (window.location.href = "/auth/login");
      if (getCurrentApp() == "cv" && isAuth.data.role != "cv")
        return (window.location.href = "/auth/login");
      if (getCurrentApp() == "cit" && isAuth.data.role != "cit")
        return (window.location.href = "/auth/login");
    }
    if (!isAuth) {
      window.location.href = "/auth/login";
    } else {
      if (
        WorkerHelpers.isSupportedBrowser() &&
        "serviceWorker" in navigator &&
        "PushManager" in window
      )
        WorkerHelpers.initPush();
    }
    window.scrollTo(0, 0);
  }, [loc.pathname]);

  return (
    isAuth && (
      <>
        {sidebarState && (
          <div
            className="fixed top-0 left-0 flex z-40 flex-col justify-center items-center bg-black bg-opacity-50 w-[100vw] h-[100vh]"
            onClick={() => {
              setSidebarState(false);
            }}
          />
        )}
        <div className="bg-white">
          <Navbar />
          <div
            id="content"
            style={{ height: "calc(100vh - 80px)" }}
            className={cx(
              "flex mt-20",
              isAuth?.data?.role === "se" ||
                isAuth?.data?.role === "mgr" ||
                isAuth?.data?.role === "flm" ||
                isAuth?.data?.role === "cit" ||
                isAuth?.data?.role === "cv"
                ? "flex-col"
                : "",
            )}
          >
            {!(
              isAuth?.data?.role === "se" ||
              isAuth?.data?.role === "mgr" ||
              isAuth?.data?.role === "tl" ||
              isAuth?.data?.role === "flm" ||
              isAuth?.data?.role === "cit" ||
              isAuth?.data?.role === "cv"
            ) && <Sidebar />}
            {(isAuth?.data?.role === "se" ||
              isAuth?.data?.role === "mgr" ||
              isAuth?.data?.role === "flm" ||
              isAuth?.data?.role === "cit" ||
              isAuth?.data?.role === "cv") && <SidebarMobile />}
            <div className="grow overflow-y-auto overflow-x-hidden bg-gray-50 flex flex-col">
              <div className="px-6 py-4 bg-white border-b border-gray-200 text-gray-500 flex gap-2 capitalize text-sm">
                {breadCrumb.map((item, index) => {
                  if (index == breadCrumb.length - 1) {
                    return (
                      <Fragment key={index}>
                        <Link
                          key={index}
                          to={item.url}
                          className="text-gray-900 font-medium hover:text-blue-600 transition-colors"
                        >
                          {item.text}
                        </Link>
                      </Fragment>
                    );
                  } else {
                    return (
                      <Fragment key={index}>
                        <Link
                          key={index}
                          to={item.url}
                          className="text-gray-900 font-medium hover:text-blue-600 transition-colors"
                        >
                          {item.text}
                        </Link>
                        <span key={index + "_span"}>/</span>
                      </Fragment>
                    );
                  }
                })}
              </div>
              <div className="p-5">
                <Suspense
                  fallback={
                    <LoadingSpinner
                      fullScreen={false}
                      size="medium"
                      message="Loading page..."
                    />
                  }
                >
                  <Outlet />
                </Suspense>
              </div>
            </div>
            {currentExport != "" && <Export />}
            {currentImport != "" && <Import />}
          </div>
        </div>
      </>
    )
  );
}
